import React from "react";
import { useApp } from "@/context/AppContext";
import { X, Globe } from "lucide-react";

const FLAGS = { nl: "🇳🇱", en: "🇬🇧", de: "🇩🇪", fr: "🇫🇷", es: "🇪🇸", it: "🇮🇹", da: "🇩🇰" };
const MSG = {
  nl: { line: "We hebben de site automatisch in jouw taal geladen.", keep: "Behouden", switch: "Overschakelen naar Nederlands" },
  en: { line: "We auto-detected your language.", keep: "Keep", switch: "Switch to English" },
  de: { line: "Wir haben die Sprache automatisch erkannt.", keep: "Behalten", switch: "Auf Deutsch wechseln" },
  fr: { line: "Nous avons détecté automatiquement votre langue.", keep: "Conserver", switch: "Passer au français" },
  es: { line: "Detectamos automáticamente tu idioma.", keep: "Mantener", switch: "Cambiar al español" },
  it: { line: "Abbiamo rilevato automaticamente la tua lingua.", keep: "Mantieni", switch: "Passa all'italiano" },
  da: { line: "Vi har automatisk registreret dit sprog.", keep: "Behold", switch: "Skift til dansk" },
};

/**
 * AutoLangBanner, shown once per session when we auto-detected a non-default
 * visitor language. Lets the visitor confirm or switch back.
 */
export default function AutoLangBanner() {
  const { autoDetectedLang, dismissAutoDetect, lang, setLang } = useApp();
  if (!autoDetectedLang) return null;
  const msg = MSG[autoDetectedLang] || MSG.en;
  const fallbackMsg = MSG[lang] || MSG.en;

  return (
    <div className="bg-[#D97742] text-white text-sm" data-testid="auto-lang-banner">
      <div className="container-x py-2 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2 min-w-0">
          <Globe className="w-4 h-4 shrink-0" />
          <span className="text-xs sm:text-sm truncate">
            {FLAGS[autoDetectedLang]} {msg.line}
          </span>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={dismissAutoDetect}
            data-testid="auto-lang-keep"
            className="px-2.5 py-1 rounded text-[11px] font-semibold bg-white/15 hover:bg-white/25 transition"
          >
            {msg.keep}
          </button>
          <button
            onClick={() => { setLang("nl"); dismissAutoDetect(); }}
            data-testid="auto-lang-switch"
            className="px-2.5 py-1 rounded text-[11px] font-semibold bg-white text-[#D97742] hover:bg-[#f5e8e0] transition"
          >
            🇳🇱 {fallbackMsg.switch}
          </button>
          <button
            onClick={dismissAutoDetect}
            aria-label="Close"
            className="p-1 hover:bg-white/15 rounded"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </div>
  );
}
